module.exports = __webpack_public_path__ + "static/img/solutionDetailIcon13.ce02a16.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailIcon13.png
// module id = mfGw
// module chunks = 0